import { SettlementResume } from "../../../models/Entities/SettlementResume/SettlementResume";
import { ErrorType } from "../../../models/HttpError";
import { AppState } from "../../../redux/reducers";
import { IIconProps } from "@fluentui/react";

// stores
import * as SettlementResumeStore from '../../../redux/middleware/SettlementResumeMiddleware';
import * as SettlementDetailsStore from '../../../redux/middleware/SettlementDetailsMiddleware';


//Entities 
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { SettlementDetail } from "../../../models/Entities/SettlementDetails/SettlementDetail";



interface IProps {
    SettlementId: number;
    SettlementSummaryItemId: number;
}
  
  interface ConnectedProps {
    isPractitionerProtocol: boolean;
    SettlementDetails: SettlementDetail[] | undefined;
    CurrentSummary: SettlementResume | undefined;
    SummaryCurrencies: string[];
  }
  
  interface DispatchProps {
    // GetSettlementResumeById: typeof SettlementResumeStore.actionCreators.GetSettlementResumeById;
    // DeleteSettlementResume: typeof SettlementResumeStore.actionCreators.DeleteSettlementResume;
    // UpdateSettlementResume: typeof SettlementResumeStore.actionCreators.UpdateSettlementResume;
    // MassExclude: typeof SettlementDetailsStore.actionCreators.MassExclude;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const settlement: Settlement | undefined = ownProps.SettlementId && state.Settlement?.list
        ? state.Settlement.list.find((item: Settlement) => item.id === ownProps.SettlementId)
        : undefined;

    return {
        Settlement: settlement,
        isPractitionerProtocol: ((settlement?.practitioner?.length ?? 0) > 0 && (settlement?.protocol?.length ?? 0) > 0),
        CurrentSummary: settlement?.resumes?.find((item: SettlementResume) => item.id === ownProps.SettlementSummaryItemId),
        SettlementDetails: settlement?.details?.filter((d: SettlementDetail) => d.settlementResumeId === ownProps.SettlementSummaryItemId),
        SummaryCurrencies: (settlement?.details?.filter((d: SettlementDetail) => d.settlementResumeId === ownProps.SettlementSummaryItemId) ?? [])
            .reduce((acc: string[], current: SettlementDetail) => {
                if (acc.indexOf(current.currency) === -1) acc.push(current.currency);
                return acc;
            }, []),
    };
  };
  
  export const mapDispatchToProps = {
    ...SettlementResumeStore.actionCreators,
    ...SettlementDetailsStore.actionCreators
  };


 //#region Icons
 export const PropertiesIcon: IIconProps = { iconName: 'DietPlanNotebook' };
 export const AddIcon: IIconProps = { iconName: 'CirclePlus' };
 export const EditIcon: IIconProps = { iconName: 'Edit' };
 export const ViewIcon: IIconProps = { iconName: 'View' };
 export const LinkContractIcon: IIconProps = { iconName: 'Link' };
 export const DeleteIcon: IIconProps = { iconName: 'Trash' };
 export const Exclude: IIconProps = { iconName: 'Share' };
 export const Include: IIconProps = { iconName: 'Download' };
 export const RefreshIcon: IIconProps = { iconName: 'SyncOccurence' };
 export const PatientDetailsIcon: IIconProps = { iconName: 'UserOptional' };